import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import serverVars from 'server-vars';
import { ReactRelayContext } from 'react-relay';
import { Provider } from 'react-redux';
import { IntlProvider } from 'dibs-react-intl';
import { ServerVarsContextProvider } from '../global/ServerVarsContext/ServerVarsContext';
import { QP_SEARCH_QUERY } from '../constants/queryParamConstants';
import {
    markPerfMetric,
    measurePerfMetric,
    PERF_METRICS,
} from 'dibs-buyer-layout/exports/perfTrackingHelpers';
import { UIDProvider } from 'dibs-uid';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

export function PrepareRelayContextProvider(props) {
    const { environment, query, variables, Component, ...otherProps } = props;
    const operation = createOperationDescriptor(getRequest(query), variables);
    environment.retain(operation);

    const snapshot = environment.lookup(operation.fragment);
    const { data } = snapshot;

    const renderProps = {
        ...variables,
        ...otherProps,
        ...data,
    };

    return (
        <ReactRelayContext.Provider
            value={{
                environment: environment,
                variables: variables || {},
            }}
        >
            <Component {...renderProps} />
        </ReactRelayContext.Provider>
    );
}

PrepareRelayContextProvider.propTypes = {
    environment: PropTypes.object.isRequired,
    query: PropTypes.func.isRequired,
    variables: PropTypes.object.isRequired,
    Component: PropTypes.elementType.isRequired,
};

export function renderEntryComponent(options) {
    const { containerId, store, ...otherProps } = options;
    const searchParams = new URLSearchParams(location.search);

    markPerfMetric(PERF_METRICS.HYDRATE);
    ReactDOM.hydrate(
        <ErrorBoundary fallback={({ error }) => <Error500Layout error={error} />}>
            <IntlProvider
                locale={serverVars.get('localeDataKey')}
                messages={serverVars.get('messages')}
            >
                <UIDProvider>
                    <ServerVarsContextProvider
                        isMobile={serverVars.get('settings.isMobile')}
                        isTablet={serverVars.get('settings.isTablet')}
                        isDesktop={serverVars.get('settings.isDesktop')}
                        isSbAdsEnabled={serverVars.get('isSbAdsEnabled')}
                        clientConf={serverVars.get('config')}
                        localeOrigin={serverVars.get('localeOrigin')}
                        isSearchQueryApplied={!!searchParams.get(QP_SEARCH_QUERY)}
                        isSbTopNavVariant={serverVars.get('isSbTopNavVariant')}
                        isSmallerSbCategoryTilesVariant={serverVars.get(
                            'isSmallerSbCategoryTilesVariant'
                        )}
                        isPdpMetaDescRemovalVariant={serverVars.get('isPdpMetaDescRemovalVariant')}
                        isStoryTellingModuleVariant={serverVars.get('isStoryTellingModuleVariant')}
                    >
                        <Provider store={store}>
                            <PrepareRelayContextProvider {...otherProps} />
                        </Provider>
                    </ServerVarsContextProvider>
                </UIDProvider>
            </IntlProvider>
        </ErrorBoundary>,
        document.getElementById(containerId),
        () => {
            measurePerfMetric(PERF_METRICS.HYDRATE, PERF_METRICS.HYDRATE);
        }
    );
}
